import mutations from './item/mutations';
import actions from './item/actions';
import getters from './item/getters';

const item = {
  namespaced: true,
  state: {
    item: {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
    },
    isLoading: false,
  },
  mutations,
  actions,
  getters,
};

export default item;
